class Socket {
  constructor(initUrl,userId,callBack,timeout = 8500) {
    this.initUrl = initUrl; //基础路径(*)
    this.userId = userId;//用户ID(*)
    this.callBack = callBack; //接收信息的回调方法

    this.lockReconnect = false; //避免重复连接
    this.wsUrl = ""; //socket路径
    this.websocket = null; //webSocket对象
    this.tt = null; //计时器

    this.heartCheck = { //心跳检测对象(每隔几秒测试一下心跳是否在继续)
      timeout: timeout, //心跳时间(*)
      timeoutObj: null,
      serverTimeoutObj: null,
      outer:this,
      start() {
        // console.log('开始测试心跳');
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(() => {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          // console.log('发送消息，测试后台是否运行中...');
          //任意发一个消息过去，后台接收，在init()中的onmessage收到消息，说明后台没有挂掉，有心跳
          let message = {
            screenSocketType: "heartbeat"
          }
          let messageString = JSON.stringify(message);
          this.outer.websocket.send(messageString);

          this.serverTimeoutObj = setTimeout(()=> {
            // console.log("后台挂掉，没有心跳了....");
            // console.log("打印websocket的地址:" + wsUrl);
            this.outer.createSocket();
          }, this.timeout);

        }, this.timeout)
      }
    };
  }

  //创建socket
  createSocket() {
    this.wsUrl = this.initUrl + this.userId
    try {
      this.websocket = new WebSocket(this.wsUrl);
      this.init();
    } catch (e) {
      console.log(this.wsUrl + ":socket创建异常,正在尝试重连");
      this.reconnect(this.wsUrl);
    }
  }

  //初始化socket
  init() {
    //连接成功建立的回调方法
    this.websocket.onopen = () => {
      console.log(this.wsUrl + ":连接成功,开始心跳检测");
      this.heartCheck.start();
	  
	  //连接上后发送修改参数请求，以便立刻获取数据
	  this.updateParameter()
    };

    //接收到消息的回调方法
    this.websocket.onmessage = (event) => {
      let message = JSON.parse(event.data)
      switch (message.screenSocketType) {
        case "heartbeat":
          this.heartCheck.start();
          console.log(this.wsUrl + ":心跳正常")
          break;
        default:
          // console.log("----业务----")
          this.callBack && this.callBack(message)
          break;
      }
    };

    //连接关闭的回调方法
    this.websocket.onclose = () => {
      console.log(this.wsUrl + ":socket关闭,正在尝试重连")
      this.reconnect(this.wsUrl);
    };

    //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
    window.onbeforeunload = () => {
      this.websocket.close();
    };

    //连接发生错误的回调方法
    this.websocket.onerror = () => {
      console.log(this.wsUrl + ":socket连接,正在尝试重连")
      this.reconnect(this.wsUrl);
    };
  }

  //重连函数
  reconnect(url) {
    if (this.lockReconnect) {
      return;
    };
    this.lockReconnect = true;
    //没连接上会一直重连，设置延迟避免请求过多
    this.tt && clearTimeout(this.tt);
    this.tt = setTimeout(() => {
      this.createSocket(url);
      this.lockReconnect = false;
    }, 20000);
  }

  //关闭连接
  closeSocket() {
    this.websocket.close();
  }

  //发送消息
  sendMessage(msgObject) {
    let messageString = JSON.stringify(msgObject);
    this.websocket.send(messageString);
  }
  
  //修改参数
  updateParameter(param){
    if(param){
      let messageString = JSON.stringify(param);
      this.websocket.send(messageString);
    }else{
      let defaultParam = {
        screenSocketType : "updateParameter"
      }
      let messageString = JSON.stringify(defaultParam);
      this.websocket.send(messageString);
    }
  }

  //其他操作
  doOperation(type,param){
    let meassage = {
      screenSocketType : "operation",
      operationType : type
    }
    if(param){
      Object.assign(meassage,param)
      console.log("doOperation",meassage)
      let messageString = JSON.stringify(meassage);
      this.websocket.send(messageString);
    }
  }
}

export {
  Socket
}



// WEBPACK FOOTER //
// ./src/utils/dd-websocket/socket.js